
class SideCart extends HTMLElement {
    constructor() {
        super();

        this.configVarsEvents(false);

    }

    configVarsEvents(is_open) {

        this.sideCartContainer = document.getElementById("section-v2-sidecart");
        this.openCartBtn = document.querySelector('[data-open="cart"]');
        this.closeCartBtn = document.querySelectorAll('.side-cart__close-button');
        this.itemsCountSelector = document.querySelector('[data-items-count]');
        this.openCartBtn.addEventListener('click', this.openSideCart.bind(this));
        this.closeCartBtn.forEach((button) => button.addEventListener('click', this.closeSideCart.bind(this)));
        this.isOpen = is_open;
        
        var cartForm = document.getElementById('SideCartForm');
        var that = this;

        document.addEventListener('click', function(event) {
          var isClickInside = cartForm.contains(event.target);
          var isClickIcon = that.openCartBtn.contains(event.target);
          if (!isClickInside && !isClickIcon) {
            that.closeSideCart();
          }
        });


        var minusQuantity = document.querySelectorAll('.side-cart-item__quantity-minus');
        var plusQuantity = document.querySelectorAll('.side-cart-item__quantity-plus');

        minusQuantity.forEach(
            (button) => button.addEventListener('click', this.reduceQuantity.bind(this))
        );

        plusQuantity.forEach(
            (button) => button.addEventListener('click', this.addQuantity.bind(this))
        );
    }


    openSideCart() {
        this.isOpen = true;
        this.sideCartContainer.classList.add("side-cart--open");
        this.sideCartContainer.classList.add("side-cart--indexed");
        document.querySelector('body').classList.add('overflow-hidden');
    }

    closeSideCart() {
        if (this.isOpen) {
            this.isOpen = false;
            document.querySelector('body').classList.remove('overflow-hidden');
            this.sideCartContainer.classList.remove("side-cart--open");
            this.sideCartContainer.classList.remove("side-cart--indexed"); 
        } 
    }

    addQuantity(event) {
        event.preventDefault();
        var line_item = event.target.closest('[data-variant-id]');
        var actual_quantity = parseInt(line_item.getAttribute("data-quantity"));
        var variant_id = line_item.getAttribute("data-variant-id");
        var new_quantity = actual_quantity + 1;

        line_item.setAttribute("data-quantity", new_quantity);
        line_item.querySelector('.h4').innerHTML = new_quantity < 10 ? "0" + new_quantity : new_quantity;

        this.updateQuantity(variant_id, new_quantity);
    }

    reduceQuantity(event) {
        event.preventDefault();
        var line_item = event.target.closest('[data-variant-id]');
        var actual_quantity = parseInt(line_item.getAttribute("data-quantity"));
        var variant_id = line_item.getAttribute("data-variant-id");
        var new_quantity = actual_quantity - 1;

        if (new_quantity == 0) {
            line_item.classList.add('hidden');
        }

        line_item.setAttribute("data-quantity", new_quantity);
        line_item.querySelector('.h4').innerHTML = new_quantity < 10 ? "0" + new_quantity : new_quantity;

        this.updateQuantity(variant_id, new_quantity);
    }

    updateQuantity(line, quantity) {
        this.enableLoading();
        var url = routes.cart_update_url + ".js";
        
        const update_label = 'updates[' + line + ']=' + quantity;

        const body = update_label
        
        fetch(url, {
            method: 'post',
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: body,
        })
        .then((response) => {
            console.dir(response);
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            console.dir(parsedState);
            this.refreshCart();
        }).catch(() => {
            //ERROR
            alert("Error : Quantity update has a problem. If you see this error please contact us.");
        });
    }

    refreshCart() {
      let url = Shopify.locale == "en" ? "/en/cart?view=json" : "/cart?view=json";
      
        fetch( url).then((response) => {
            if (response.ok) {
                return response.text();
            } else {
                alert("Error : Refresh cart has a problem. If you see this error please contact us.");
            }
          })
          .then((response) => {
                document.querySelector('.side-cart__wrapper').innerHTML = response;

                var nb_items = document.querySelector('[data-nb-items]').getAttribute('data-nb-items')
                document.querySelector('[data-items-count]').innerHTML = nb_items;

                this.configVarsEvents(true);
                this.disableLoading();

                if (!(document.querySelector('.side-cart').classList.contains('side-cart--open'))) {
                    this.openSideCart();
                }
          })
          .catch((error) => {
            alert("Error : Refresh cart has a problem. If you see this error please contact us.\n" + error);
          });
    }

    enableLoading() {
        document.querySelector('#SideCartForm').classList.add('loading');
    }

    disableLoading() {
        document.querySelector('#SideCartForm').classList.remove('loading'); 
    }
}

customElements.define('side-cart', SideCart);
  